
import { A2AMessage } from '../types';
import { messageBus } from './core/MessageBus';

export function broadcast(
  fromAgent: string,
  toAgents: string[],
  content: string,
  metadata: any = {}
): A2AMessage[] {
  return toAgents.map(agentId => {
    const message: A2AMessage = {
      id: `broadcast-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
      fromAgent,
      toAgent: agentId,
      content,
      timestamp: new Date(),
      signature: '',
      keyId: '',
      metadata: {
        protocol: 'A2A',
        version: '1.1',
        messageType: 'NOTIFICATION',
        routingBehavior: 'broadcast',
        ...metadata
      }
    };
    
    messageBus.publish(message);
    return message;
  });
}

export function createBidirectionalChannel(
  agentIds: string[],
  metadata: any = {}
): string {
  if (agentIds.length < 2) {
    throw new Error('At least two agents are required for a bidirectional channel');
  }
  
  const channelId = `channel-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  
  agentIds.forEach(agentId => {
    const otherAgents = agentIds.filter(id => id !== agentId);
    
    const message: A2AMessage = {
      id: `channel-create-${channelId}-${agentId}`,
      fromAgent: 'system',
      toAgent: agentId,
      content: `You've been added to a communication channel with: ${otherAgents.join(', ')}`,
      timestamp: new Date(),
      signature: '',
      keyId: '',
      metadata: {
        protocol: 'A2A',
        version: '1.1',
        messageType: 'COORDINATION',
        channelId,
        participants: agentIds,
        ...metadata
      }
    };
    
    messageBus.publish(message);
  });
  
  return channelId;
}
